import { findDataSources } from '~/Api/Analytics/DataSource';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchDataSources(): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findDataSources));
		dispatch({ type: ActionTypes.request, request });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				dataSources: response?.items,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}
